export const changePasswordResourceType = "change_password" as const;
export const changePasswordResourcePath = "/change_password" as const;
